<div>
    <app-toolbar-layout></app-toolbar-layout>   
    <div class="layout-main-container" style="margin-left: 45px;">
        <div class="layout-main">  
            <router-outlet></router-outlet>
        </div>
    </div>
    <app-filter-layout #sidebar></app-filter-layout>
    <app-menu-layout #appMenu></app-menu-layout>
</div>
